export default class Base {
  id?: string;
  createdAt?: number;
  modifiedAt?: number;
  createdBy?: string;
  modifiedBy?: string;
}
